import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/settings/server/$serverId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/settings/server/$serverId/general", params });
  },
});
